"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OlympusConstants = exports.ClientError = exports.createClient = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable @typescript-eslint/no-namespace */
var client_1 = require("./client");
Object.defineProperty(exports, "ClientError", { enumerable: true, get: function () { return client_1.ClientError; } });
var metadata_1 = __importDefault(require("./metadata"));
exports.createClient = (0, client_1.generateClientFactory)(metadata_1.default);
exports.OlympusConstants = {
    auth: {
        AUDIENCES: ["vesta", "mercury", "mercury:guest", "hermes", "dionysus:guest", "dionysus", "eris"],
        AVAILABLE_ROLES: [],
        SUBJECT_TYPES: ["customer", "guest", "user", "device", "application"],
    },
    billing: {
        LOCATION_SUBSCRIPTION_STATUSES: ["active", "past_due", "delinquent", "cancelled", "paused"],
        LOCATION_SUBSCRIPTION_TIERS: ["growth-demo", "standard"],
    },
    checkout: {
        CHECKOUT_AVAILABILITY_STATUSES: ["enabled", "disabled", "paused"],
        ORDER_STATUSES: ["unclaimed", "claimed", "cancelled", "completed", "voided"],
        ORDER_TIMINGS: ["asap", "scheduled"],
        ORDER_TYPES: ["pickup", "delivery", "store"],
    },
    customer: {
        SUBSCRIPTION_TYPE: ["email", "sms", "push"],
    },
    delivery: {
        DELIVERY_PROVIDERS: ["doordash", "ubereats", "inhouse"],
        DELIVERY_ZONE_TYPES: ["serviceable", "restricted"],
        MAX_DOORDASH_DISTANCE: 16093.44,
        THIRD_PARTY_PROVIDERS: ["doordash", "ubereats"],
    },
    forms: {
        DISPLAY_SECTION_TYPES: ["headline", "subheading"],
        FORM_TYPES: ["contact", "catering", "event", "custom"],
        INPUT_SECTION_TYPES: ["text-field", "email", "name", "phone", "select", "multi-select", "date", "address"],
        SECTION_TYPES: ["text-field", "email", "name", "phone", "select", "multi-select", "date", "address", "headline", "subheading"],
        TEXT_FIELD_VARIANTS: ["multiline", "number"],
    },
    funnel: {
        ACTION_LINKS: ["profile", "loyalty", "orders"],
        BANNER_ICONS: ["Info", "Confetti", "Pizza", "ForkKnife", "Gift", "CreditCard", "Money", "CurrencyCircleDollar", "CalendarBlank", "BookOpen", "Phone", "Crown", "Desktop", "PaperPlaneTilt", "Notepad", "Newspaper", "car", "card", "cart", "delivery", "dish", "domains", "heart", "leaf", "overview", "phone", "pin", "star", "story", "team", "time", "tote", "work"],
        CONTENT_LAYOUTS: ["generic", "cover"],
        FEATURE_ICONS: ["car", "card", "cart", "delivery", "dish", "domains", "grains-slash", "heart", "leaf", "overview", "phone", "pin", "star", "story", "team", "time", "tote", "work"],
        FOOTER_LAYOUTS: ["generic", "image"],
        GENERATED_PAGE_NAMES: ["nearby-area", "keyword"],
        INVALID_BANNER_REASONS: ["disabled", "expired", "not-valid-yet", "invalid-location"],
        INVALID_PAGE_REASONS: ["disabled", "page-disabled", "gift-cards-disabled", "loyalty-disabled", "olo-disabled", "no-gift-card-section", "no-careers-section", "no-event-calendar-section", "no-menu-section", "location-missing"],
        INVALID_SECTION_REASONS: ["disabled", "gift-cards-disabled", "olo-disabled", "events-disabled", "feature-flagged"],
        LANDING_HERO_LAYOUTS: ["card", "cover", "cover-center"],
        LOGO_SIZES: ["sm", "md", "lg"],
        NAVIGATION_LAYOUTS: ["logo-left", "logo-center"],
        NAV_PATH_TYPES: ["action", "external", "generated", "page", "partner"],
        PAGE_PATH_TYPES: ["reserved", "custom", "generated"],
        PHOTO_LAYOUTS: ["carousel", "carousel-cover", "full", "grid"],
        RESERVED_PAGES: ["index", "order", "location", "story", "events", "careers", "gift"],
        REVIEW_STARS: [1, 2, 3, 4, 5],
        SECTION_LAYOUTS: ["generic", "photo-card", "photo-background"],
        SECTION_TYPES: ["locations", "careers", "content", "event-calendar", "form", "gallery", "gift-cards", "hero", "landing-hero", "menu", "pdf", "reviews", "top-picks", "video", "features", "faq"],
        TOP_PICKS_LAYOUTS: ["carousel-mini", "carousel-full", "gallery"],
    },
    generator: {
        GENERATION_STATUSES: ["processing", "error", "timeout", "cancelled", "success"],
        TASKS: ["aboutImage", "aboutContent", "location", "logo", "address", "bannerImage", "brand", "classification", "headline", "gmb", "googlePhotos", "menuItems", "menuPhotos", "reviews", "theme", "writeOutput", "freshIngredientsContent", "freshIngredientsPhoto", "madeWithLoveContent", "madeWithLovePhoto", "googleSearchProfile"],
        TASK_STATUSES: ["pending", "processing", "error", "cancelled", "success"],
    },
    giftCard: {
        GIFT_CARD_CHARGE_TYPES: ["in-store", "online", "hermes"],
    },
    kitchen: {
        DEVICE_TYPES: ["kitchen"],
    },
    legal: {
        AGREEMENT_TYPES: ["restaurant-agreement", "customer-agreement"],
    },
    listings: {
        LISTING_ISSUE_LEVELS: ["warning", "error"],
        LISTING_ISSUE_TYPES: ["mismatch", "missing"],
        LISTING_REQUIRED_OWNER_FIELDS: ["address", "phone", "name", "cuisine", "url", "isPickupEnabled", "isDeliveryEnabled"],
    },
    menuImport: {
        SYNC_STATUSES: ["pending", "success", "failed", "cancelled"],
    },
    mobileApp: {
        DEPLOYMENT_STATUSES: ["queued", "in-progress", "completed", "failed", "cancelled"],
    },
    notifications: {
        CTA_LINK_TYPES: ["order", "gift-card"],
        VOICE_TONES: ["friendly", "elegant", "playful", "informative", "persuasive", "casual", "yoda"],
    },
    partner: {
        BRAND_PRICE_RANGES: [0, 1, 2, 3],
        CUISINES: ["african", "african-fusion", "american", "argentinian", "asian", "asian-fusion", "bagels", "bakery", "bar", "bar-&-grill", "bbq", "boba", "burritos", "brazilian", "breakfast", "brewery", "british", "burgers", "burmese", "cafe", "cajun", "caribbean", "catfish", "chicken-&-waffles", "chili", "chinese", "coffee", "creole", "crepes", "cuban", "deli", "dessert", "diner", "dominican", "donuts", "ethiopian", "filipino", "french", "fried-chicken", "frybread", "georgian", "german", "greek", "grilled-chicken", "guatemalan", "halal", "haitian", "hawaiian", "healthy", "honduran", "ice-cream", "indian", "irish", "italian", "jamaican", "japanese", "kebab", "korean", "latin-american", "lebanese", "malaysian", "meal-prep", "mediterranean", "mexican", "mexican-fusion", "middle-eastern", "nepalese", "nicaraguan", "pakistani", "peruvian", "pho", "pizza", "poke", "polynesian", "portuguese", "puerto-rican", "ramen", "russian", "salads", "sandwiches", "seafood", "soul-food", "southern", "southwestern", "spanish", "sports-bar", "steakhouse", "sushi", "tacos", "taiwanese", "tamales", "tapas", "thai", "turkish", "ukrainian", "upscale", "vegan", "vegetarian", "venezuelan", "vietnamese", "wings", "salvadoran", "family-friendly", "acai-bowl", "taiyaki", "waffles", "laos", "juice-bar", "polish", "comfort-food", "hibachi", "cambodian", "lesbian-bar", "dog-friendly", "hot-dogs", "catering", "food-truck", "tea-shop", "brewpub", "fast-food", "brunch", "falafel", "kosher", "butcher-shop", "meat-product-store", "jewish", "vegetarian-cafe", "vegetarian-deli", "colombian", "european", "fine-dining", "tex-mex", "grocery-store", "fresh-food-market", "jerk-chicken", "soup", "dumpling", "persian", "yakitori", "cheesesteak", "hookah-bar"],
        LOCATION_STATUSES: ["onboarding", "live", "closed", "cancelled"],
    },
    theme: {
        BACKGROUND_COLOR_KEYS: ["primary", "secondary", "divider", "opacity"],
        BASIC_COLOR_TYPES: ["red", "orange", "green", "blue"],
        BASIC_PALETTE_KEYS: [100, 200, 300, 400],
        BRAND_COLOR_KEYS: ["primary", "accessibleOverPrimary"],
        BRIGHTNESS_PALETTES: ["light", "dark"],
        FONTS: ["Abril Fatface", "Cabin", "Poppins", "DM Sans", "Manrope", "Playfair Display", "IBM Plex Sans", "Oswald", "Cardo", "Syne", "Nunito", "Noto Serif Display", "Raleway", "Inter"],
        FULL_COLOR_TYPES: ["neutral"],
        FULL_PALETTE_KEYS: [100, 200, 300, 400, 500, 600, 700, 800],
        PAIRINGS: ["chic", "geometric", "modern", "elegant", "urban", "super", "luxury"],
        PALETTE_KEYS: ["red.100", "red.200", "red.300", "red.400", "orange.100", "orange.200", "orange.300", "orange.400", "green.100", "green.200", "green.300", "green.400", "blue.100", "blue.200", "blue.300", "blue.400"],
        TEXT_COLOR_KEYS: ["primary", "secondary", "placeholder"],
        THEME_NAMES: ["opal"],
        UX_COLOR_SYSTEMS: ["success", "warning", "danger", "info"],
    },
    marketing: {
        AUTOMATIC_CAMPAIGN_ENTRANCE_CONDITIONS: ["signup", "subscribed", "email-subscribed", "sms-subscribed", "has-not-ordered-recently", "customer-has-ordered", "new-customer", "not-in-automated-campaign", "eligible-for-conversion-cards"],
        AUTOMATIONS: ["abandonment", "basic", "welcome", "winback"],
        BLOCK_ACTION_TYPES: ["send-email", "send-sms", "send-push", "send-to-campaign"],
        BLOCK_TYPES: ["action", "condition", "trigger"],
        CAMPAIGN_ERROR_TYPES: ["resource-not-found", "section-data-missing", "no-domain-found-for-brand", "cannot-determine-customer-location", "unknown-error"],
        CAMPAIGN_PARTICIPANT_TYPES: ["customer", "guest", "partner"],
        CAMPAIGN_STATUSES: ["draft", "scheduled", "populating", "active", "processing", "paused", "error", "archived", "completed"],
        CAMPAIGN_TRANSPORTS: ["email", "sms"],
        CAMPAIGN_TYPES: ["one-time", "automated"],
        MESSAGE_DELIVERY_STATUSES: ["sent", "delivered", "bounced", "suppressed", "opened", "failed", "clicked", "queued"],
        MESSAGE_TYPES: ["email", "sms", "push"],
        UTM_MEDIUMS: ["organic", "phone", "email", "text", "flyer", "poster", "sticker", "tabletent", "cpc", "gmb-post", "gmb-offer", "gbp-ad-exact", "gbp-ad-keyword", "search-ad-direct", "search-ad-keyword"],
        UTM_SOURCES: ["owner", "google", "facebook", "instagram", "yelp", "referral", "import"],
    },
    menu: {
        COUPON_RESET_PERIOD: ["immediate", "day", "week", "month", "year"],
        COUPON_TYPES: ["ticket-percent", "ticket-fixed", "item-percent", "item-fixed"],
        MENU_TYPES: ["olo", "catering"],
    },
    pos: {
        MENU_SYNC_SUPPORTED: ["clover", "otter"],
    },
    processing: {
        PAYOUT_STATUS: ["paid", "pending", "in_transit", "canceled", "failed"],
        PAYOUT_TYPE: ["automatic", "instant"],
        RECONCILIATION_STATUS: ["pending", "complete", "not_applicable"],
        VALID_STRIPE_TYPES: ["charge", "refund"],
        VALID_SUBJECT_TYPES: ["order", "gift-card-payment"],
        VALID_TYPES: ["charge", "refund", "dispute", "dispute-reversal"],
    },
    sms: {
        APPROVAL_STATUS: ["not-submitted", "invalid", "pending", "approved", "rejected"],
    },
    template: {
        EMAIL_SECTION_TYPES: ["heading", "subheading", "paragraph", "photo", "coupon", "item", "info-card", "cta", "gift-card"],
        SMS_SECTION_TYPES: ["text", "attachment"],
    },
};
//# sourceMappingURL=index.js.map